export const formatDate = (dateString) => {
    // Split the date string into its components
    const dateComponents = dateString.split(' ');
  
    // Check if the components match the expected format
    if (dateComponents.length === 6 && dateComponents[1] && dateComponents[2]) {
      const day = dateComponents[0];
      const monthName = dateComponents[1];
      const year = dateComponents[2];
      const time = dateComponents[4].toLowerCase();
      const ampm = dateComponents[5].toUpperCase();
      const months = {
        January: '01',
        February: '02',
        March: '03',
        April: '04',
        May: '05',
        June: '06',
        July: '07',
        August: '08',
        September: '09',
        October: '10',
        November: '11',
        December: '12',
      };
       // Get the numeric month value from the month name
const month = months[monthName];

return `${day}/${month}/${year}   ${time} ${ampm}`;
}

return 'Invalid Date'; // Handle invalid date strings
};


export const formatDateNoTime = (dateString) => {
  // Split the date string into its components
  const dateComponents = dateString.split(' ');

  if (dateComponents.length === 3) {
    const day = dateComponents[0];
    const monthName = dateComponents[1];
    const year = dateComponents[2];

    // Map month names to their numeric values
    const months = {
      January: '01', February: '02', March: '03', April: '04',
      May: '05', June: '06', July: '07', August: '08',
      September: '09', October: '10', November: '11', December: '12',
    };

    const numericMonth = months[monthName];

    return `${day}/${numericMonth}/${year}`;
  }

  return 'Invalid Date'; // Handle invalid date strings
};
